export default "__VITE_ASSET__B78PA9If__"